var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"tab-pane fade",class:_vm.css,attrs:{"role":"tabpanel"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }